import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useActions, useAppSelector } from 'state/store';
import * as ROUTES from 'routes';
import {
  validateToken,
  isTokenExpired,
  clearLocalStorage,
} from '@ihsm/ui-shared';
import { AuthRoutes } from './AuthRoutes';
import { AppRoutes } from './AppRoutes';

export const RoutesWithAuth: React.FC = (): JSX.Element => {
  const {
    loginRequired,
    apiAuthTokenRequired,
    token: existingToken,
  } = useAppSelector((state) => state.authState);
  const { setToken } = useActions();
  const { search, pathname } = useLocation();
  const history = useHistory();

  // validateToken needs to rerun on every render
  // as token could have expired since the last render
  const showLoginForm = (() => {
    if (!loginRequired) return false;
    const tokenIsValid = validateToken();
    return !tokenIsValid;
  })();

  useEffect(() => {
    if (apiAuthTokenRequired) {
      const parsedQuery = queryString.parse(window.location.search);
      const authTokenFromURL = parsedQuery.auth_token as string;
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}/${window.location.hash}`
      );
      const isFromLaunchpad = new URLSearchParams(search)
        .get('demo_launchpad')
        ?.toLowerCase() as string;

      if (authTokenFromURL && !isTokenExpired(authTokenFromURL)) {
        setToken(authTokenFromURL);
      } else if (existingToken && isTokenExpired(existingToken)) {
        clearLocalStorage();
        if (isFromLaunchpad === 'true') {
          window.location.replace(ROUTES.LAUNCHPAD_URL);
        }
      }
    }
  }, [apiAuthTokenRequired, existingToken, search, setToken]);

  useEffect(() => {
    if (showLoginForm && pathname !== ROUTES.SIGN_IN) {
      history.push(ROUTES.SIGN_IN);
    }
  }, [history, pathname, showLoginForm]);

  return showLoginForm ? <AuthRoutes /> : <AppRoutes />;
};
